<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col cols="10" class="pa-0" md="5" sm="6">
            <v-form ref="form" @submit.prevent="$refs.form?.isValid && submit()">
                <p class="text-primary mb-4 font-weight-medium">شیفت کاری جدید</p>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="form.name"
                ></v-text-field>
                <v-textarea
                    :rules="$validation()"
                    label="توضیحات"
                    class="mt-3"
                    no-resize
                    rows="3"
                    v-model="form.description"
                ></v-textarea>
                <p class="text-primary mt-3 font-weight-medium text-meta">انتخاب روزها</p>
                <v-btn-group class="mt-4" divided multiple>
                    <v-btn
                        :color="form.content[tag.slug].enabled ? 'secondary' : 'grey-lighten-3'"
                        class="text-grey-darken-2"
                        @click="()=>{form.content[tag.slug].enabled = !form.content[tag.slug].enabled;}"
                        v-for="tag in daysOfWeek"
                        :key="tag.slug"
                    >{{ tag.name }}</v-btn>
                </v-btn-group>
                <div class="text-primary" v-for="(item, name, index) in form.content" :key="index">
                    <div v-if="item.enabled">
                        <p class="mt-6 mb-4 text-meta" v-text="workingTimeName(name)"></p>
                        <v-row align="center" class="mx-0 mb-4" v-for="(inner, index) in item.items" :key="index" wrap>
                            <time-picker
                                :disabled="index > 0 && !item.items[index - 1].to"
                                :min="index > 0 ? item.items[index - 1].to : ''"
                                :max="inner.to"
                                v-model="inner.from"
                                :max-width="100"
                                hide-details
                                clearable
                                :rules="$validation('required')"
                            ></time-picker>
                            <p class="text-center text-primary mx-sm-6 mx-2">تا</p>
                            <time-picker
                                v-model="inner.to"
                                :min="inner.from"
                                :max="(index + 1) < item.items.length && item.items[index + 1].from ? item.items[index + 1].from : ''"
                                :max-width="100"
                                hide-details
                                clearable
                                :rules="$validation('required')"
                            ></time-picker>
                            <v-btn @click="item.items.splice(index, 1)" variant="text" color="red-darken-2" v-if="item.items.length != 1" icon="clear"></v-btn>
                            <v-btn @click="item.items.push({from: null, to: null})" variant="text" color="primary" v-if="index == item.items.length - 1 && item.items.length < 4" icon="add"></v-btn>
                        </v-row>
                    </div>
                </div>
                <div class="mt-9">
                    <v-btn type="submit" color="success" :disabled="!Object.values(form.content).some(x => x.enabled)" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings/workingShift' })" variant="text" class="ms-2" color="error" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "ویرایش",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.workingshift;
    },
    data() {
        return {
            loading: false,
            date: null,
            daysOfWeek: [
                { name: "شنبه", slug: "sat" },
                { name: "يكشنبه", slug: "sun" },
                { name: "دوشنبه", slug: "mon" },
                { name: "سه‌شنبه", slug: "tue" },
                { name: "چهارشنبه", slug: "wed" },
                { name: "پنجشنبه", slug: "thu" },
                { name: "جمعه", slug: "fri" },
            ],
            form: {
                name: null,
                description: null,
                content: {
                    sat: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    sun: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    mon: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    tue: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    wed: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    thu: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                    fri: {
                        enabled: false,
                        items: [
                            {
                                from: null,
                                to: null,
                            },
                        ],
                    },
                },
            },
        };
    },
    methods: {
        workingTimeName(key) {
            return this.daysOfWeek.find((x) => x.slug == key).name;
        },
        submit() {
            this.loading = true;
            let result = {};
            result.content = JSON.stringify(this.form.content);
            result.name = this.form.name;
            result.description = this.form.description;
            this.$workingShiftUpdate(this.$route.params.id, result).then(res => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.clearAdminDefaults();
                    this.$system.clearWorkingshifts();
                    this.$router.push({path: '/settings/workingShift'})
                }
            }).finally(()=>{this.loading = false});
        },
        async getWorkingShifts() {
            await this.$workingShiftGet(this.$route.params.id).then((res) => {
                if (res && res.status == "OK") {
                    this.form.name = res.data.name;
                    this.form.description = res.data.description;
                    let content = JSON.parse(res.data.content);
                    this.daysOfWeek.forEach((element) => {
                        this.form.content[element.slug] = content[element.slug];
                    });
                }
            });
        },
    },
    async created() {
        this.$loading.start();
        await this.getWorkingShifts();
        this.$loading.finish();
    },
};
</script>
